import { useHasAccess } from 'lib-shared-access-control';
import { Navigate, Route, Routes } from 'react-router-dom';

import { useFeatureFlag } from 'utils/featureFlagging/useFeatureFlag';

import { SettingsChatbotsView } from './settingsChatbots.view';
import { DataSourceWrapper } from './views/dataSourceWrapper';
import { MimWrapper } from './views/mimWrapper';
import {
  MimChatbotIdentityView,
  MimChatbotSourcesView,
  MimChatbotView,
} from './views/mimWrapper/components/mim';
import { SettingsChatbotsThirdPartyView } from './views/thirdParty';

const SettingsChatbotsRoutes = (): JSX.Element | null => {
  const hasIntegrationApiAccess = useHasAccess('settings.integration.api');
  const flags = useFeatureFlag([
    'ada-chat-channel',
    'digitalgenius-chat-channel',
    'kindly-chat-channel',
    'mim-chatbot',
    'website-data-source',
  ]);

  if (Object.values(flags).every((flag) => !flag)) {
    return null;
  }

  return (
    <Routes>
      {flags.mimChatbot && (
        <Route path="mim/:id/*" element={<MimChatbotView />}>
          <Route index element={<Navigate to="identity" />} />
          <Route path="identity" element={<MimChatbotIdentityView />} />
          <Route path="sources" element={<MimChatbotSourcesView />} />
        </Route>
      )}

      {flags.websiteDataSource && (
        <Route path="data-source/:id/*" element={<DataSourceWrapper />} />
      )}

      <Route path="*" element={<SettingsChatbotsView />}>
        {flags.mimChatbot && <Route path="mim" element={<MimWrapper />} />}

        {hasIntegrationApiAccess &&
          (flags.adaChatChannel ||
            flags.digitalgeniusChatChannel ||
            flags.kindlyChatChannel) && (
            <Route
              path="third-party"
              element={<SettingsChatbotsThirdPartyView />}
            />
          )}

        <Route
          index
          element={<Navigate to={flags.mimChatbot ? 'mim' : 'third-party'} />}
        />
      </Route>
    </Routes>
  );
};

export const settingsChatbotsRoutes = (
  <Route path="chatbots/*" element={<SettingsChatbotsRoutes />} />
);
